import streamSaver from 'streamsaver'

export default streamSaver
